<mat-dialog-content>
  <h3>Apply Edits to Multiple Stores</h3>
  @if (edits.length > 0) {
    <div class="edits-section" style="margin-bottom: 1em">
      <div style="font-weight: 500">Edits:</div>
      @for (edit of edits; track edit) {
        <div style="color: #444">{{ edit }}</div>
      }
    </div>
  }
  <multi-store-dropdown [(facilities)]="facilities" [currentFacilityId]="currentFacility"></multi-store-dropdown>
  <div class="button-container">
    <button mat-button color="warn" (click)="onNoClick()">Exit</button>
    <button mat-flat-button color="accent" [mat-dialog-close]="facilities">Apply</button>
  </div>
</mat-dialog-content>
